import _ from 'lodash';
import { createClient } from '@/shared/api';
import type { FlaggedStudiesQuery, FlaggedStudiesQueryVariables } from '@/shared/api';
import FLAGGED_STUDIES_QUERY from '../queries/flaggedStudies';

/**
 * Loads a paged, filtered set of flagged studies. Runs FLAGGED_STUDIES_QUERY with filter, limit and page and throws the first GraphQL error message when flaggedStudies is nil.
 *
 * @param filter - Filter criteria forwarded to the GraphQL query.
 * @param limit - Maximum number of records to return, defaulting to 10.
 * @param page - Zero-based page index, defaulting to the first page.
 * @returns The flagged studies page.
 */
const fetchFlaggedStudies = async (
  filter: FlaggedStudiesQueryVariables['filter'],
  limit = 10,
  page = 0,
): Promise<FlaggedStudiesQuery['flaggedStudies']> => {
  const client = createClient();
  const result = await client.query<FlaggedStudiesQuery, FlaggedStudiesQueryVariables>({
    query: FLAGGED_STUDIES_QUERY,
    variables: {
      filter,
      limit,
      page,
    },
  });
  const { data, errors } = result;
  const { flaggedStudies } = data;
  if (_.isNil(flaggedStudies) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return flaggedStudies;
};

export default fetchFlaggedStudies;
